export default "__VITE_ASSET__D2g0W19f__"